<template>
  <div class="c-product-info__add-to-cart">
    <div :class="['u-text-align-center']">
      <product-notification
        :product="product"
      />
      <p 
        v-if="showSelectSize.showVariant"
        class="t-heading-8 c-add-to-cart-btn__error u-margin-bottom-xx-small"
      >
        PLEASE SELECT A SIZE
      </p>
      <p
        v-if="showSelectSize.showDefault"
        class="t-paragraph"
      >
        <span>You need to select a size before you can</span>
        <span v-if="showEngraving"> engrave or</span>
        <span> add to cart</span>
      </p>
      <p
        v-else-if="!selectedVariant && isGiftCard"
        class="t-paragraph"
      >
        You need to select a price before you can add to cart
      </p>
      <btn
        v-if="showEngraving && showAddToCart"
        type="primary-open"
        :button-size="['thin', 'large']"
        :is-disabled="engravingDisabled && !atcBtn.variant1"
        class="u-margin-bottom-small"
        @click="startEngraving"
      >
        <span> Add Engraving - </span>
        <product-price
          :price="engravingPrice"
          :compare-at-price="engravingCompareAtPrice"
        />
      </btn>
    </div>
    <slot />
  </div>
</template>
<script>
import Btn from '../button/Btn'
import get from 'lodash/get'
import getEngravingPrice from '@/mixins/getEngravingPrice'
import abTesting from '@mixins/abTesting';
import ProductPrice from '../productPrice/ProductPrice'
import ProductNotification from './ProductNotification.vue'
import { mapState } from 'vuex'
export default {
  components: {
    ProductPrice,
    Btn,
    ProductNotification,
  },
  mixins: [
    getEngravingPrice,
    abTesting
  ],
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: [Number, String],
      default: null
    },
    showAddToCart: {
      type: Boolean,
      default: true
    },
    selectedVariant: {
      type: Object,
      default: null
    },
    isGiftCard: {
      type: Boolean,
      default: false
    },
    isBundle: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectionError: false
    }
  },
  computed: {
    showEngraving() {
      const product = this.product
      return !!get(product, 'metafieldsMap.engraving')
    },
    engravingDisabled() {
      const selectedVariant = this.selectedVariant
      return selectedVariant ? !selectedVariant.availableForSale : true
    },
    showSelectSize() {
      const selectionError = this.selectionError
      const isGiftCard = this.isGiftCard
      const selectedVariant = this.selectedVariant
      const abTesting = this.abTesting
      const atcBtn = this.atcBtn
      const product = this.product
      let result = {
        showVariant: false,
        showDefault: false
      }
      if(!isGiftCard && !selectedVariant) {
        if(selectionError && abTesting && atcBtn.variant1) {
          result.showVariant = true
        } else if (product.variants.length > 1 && !atcBtn.variant1) {
          result.showDefault = true
        }
      }
      return result
    },
    ...mapState('vwo',['atcBtn'])
  },
  methods: {
    startEngraving() {
      if(this.selectedVariant) {
        this.selectionError = false
        let engravingData = {
          variant: this.selectedVariant,
          size: this.size,
          isBundle: false
        };
        this.$emit("engraving", engravingData);
      } else if (this.abTesting && this.atcBtn.variant1) {
        this.selectionError = true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.c-add-to-cart-btn {
  &__error {
    color: red;
  }
}
</style>
